"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const i18n = require("i18n");
const styles = require("./SensitiveContentTag.less");
const SensitiveContentTag = () => (React.createElement("div", { className: styles.tag }, i18n.get('SENSITIVE_CONTENT')));
exports.default = SensitiveContentTag;
